<template>

<div style="margin: 5px;">
    <InputGroup>
    <InputGroupAddon>Supplier type</InputGroupAddon>
    <Dropdown v-model="value" 
        :options="options" 
        placeholder="Supplier type" 
        optionLabel="name"
            optionValue="id"   
            :disabled="disabled" 
            :required="required"
            :class="{'p-invalid': isError}" />
</InputGroup>
</div>


     
</template>  
<script>

export default {
    props: ['modelValue',  'disabled','required'],
    emits:["update:modelValue","update:error"],
    components: {

    },
    data() {
        return {
            value: null,
            options: [
                { id: 'A', name: 'A: Manufacturer' },
                { id: 'B', name: 'B: Vendor' },
                { id: 'C', name: 'C: Manufacturer & Vendor' } ,
                { id: 'E', name: 'E: No Manufacturer & Vendor code' }
            ]
        }
    },
    created() {
         
        this.value=this.modelValue;
        if(this.is_XXSourcer || this.is_Supervisor || this.is_VendorUser)
        {
            this.options = [
                { id: 'A', name: 'A: Manufacturer' },
                { id: 'B', name: 'B: Vendor' },
                { id: 'C', name: 'C: Manufacturer & Vendor' },
                { id: 'D', name: 'D: XX/YY Material supplier' },
                { id: 'E', name: 'E: No Manufacturer & Vendor code' }
                 
            ];
        }
        else 
        {
            this.options = [
                { id: 'A', name: 'A: Manufacturer' },
                { id: 'B', name: 'B: Vendor' },
                { id: 'C', name: 'C: Manufacturer & Vendor' },
                { id: 'E', name: 'E: No Manufacturer & Vendor code' }
            ];
        }
        
    },
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
      computed:{
        isError(){
            return  !this.value;
        },
        user_sourcerMapping() {
            return this.$store.state.user?.SourcerMapping;
        },
        user_sourcerMapping2() {
            let ret=[];
            if(this.user_sourcerMapping){
                const arrayOfStrings = this.user_sourcerMapping.split(",");
                ret = arrayOfStrings.map(x=>x.substring(0,2));
            }
            return ret;
        },
        is_XXSourcer() {
           let b=false;
           let a = this.user_sourcerMapping && this.user_sourcerMapping.includes("S4Z")
           if(this.user_sourcerMapping2 && this.user_sourcerMapping2.length>0){
                b = this.user_sourcerMapping2.includes("SX") || this.user_sourcerMapping2.includes("SY");
            }
            let c= a || b ;
           return c;
        },
        user_roles() {
        return this.$store.state.user?.Roles;
        },
        is_CompalUser(){
            return this.user_roles && this.user_roles.includes('CompalUser');
        },
        is_VendorUser(){
            return this.user_roles && this.user_roles.includes('VendorUser');
        },
        is_Supervisor(){
            return this.user_roles && this.user_roles.includes('Supervisor');
        },
    },
    watch: {
            /*  modelValue: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            }, */
            value: function (newVal) {
              // watch it
              //console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
 
}
</script>
  
  